export default {
  subtitle: "深入分析欧盟CBAM碳合规，帮助中小企业快速了解法规和市场趋势",
  feature1: "CBAM介绍",
  feature2: "合规流程",
  feature3: "市场趋势",
  feature4: "我们的产品如何帮助企业",
  seo_title: "欧盟CBAM碳合规指南",
  section1_title: "CBAM介绍",
  section1_content1: "欧盟碳边境调节机制(CBAM)是欧盟为应对气候变化而推出的一项重要政策措施。",
  section1_content2:
    "该机制旨在防止碳泄漏，确保进口商品在碳排放成本方面与欧盟境内生产的商品处于公平的竞争环境中。",
  section1_content3:
    "CBAM要求将特定高碳排放商品进口到欧盟的进口商购买相当于欧盟国内生产商承担的碳成本的相应碳排放配额。",
  section2_title: "合规流程",
  section2_content: "CBAM合规流程包括四个关键步骤：",
  section2_step1: "申报：进口商需要在CBAM系统中注册，并定期申报进口商品的碳排放量",
  section2_step2: "核查：申报的碳排放数据需要由第三方核查机构进行核查",
  section2_step3: "购买配额：根据核查后的碳排放量购买相应的CBAM证书",
  section2_step4: "通关：完成CBAM证书购买后，商品方可进入欧盟市场",
  section3_title: "市场趋势",
  section3_content: "CBAM正在不断演进发展，主要趋势包括：",
  section3_trend1: "扩大范围：CBAM将逐步扩展到更多行业，包括有机化学品和塑料制品",
  section3_trend2: "标准趋严：欧盟将持续提高碳排放核算的准确性和透明度要求",
  section3_trend3: "全球影响：CBAM正在推动全球贸易伙伴建立或调整自身的碳定价机制",
  section3_trend4: "技术发展：数字化工具和自动化系统在碳排放核算中发挥越来越重要的作用",
  section4_title: "我们的产品如何帮助企业",
  section4_content: "我们的产品可以帮助企业高效应对CBAM合规要求：",
  section4_benefit1: "精确计算：基于欧盟官方因子和自定义因子提供精确的碳排放计算",
  section4_benefit2: "高效合规：自动生成符合CBAM要求的报告，简化申报流程",
  section4_benefit3: "批量处理：支持大批量数据处理，提高工作效率",
  section4_benefit4: "API集成：轻松与ERP和电商系统集成，实现自动化合规报告",
  download_title: "立即下载白皮书",
  email_placeholder: "请输入您的邮箱",
  agreement_text: "我同意使用此邮箱接收白皮书，并同意根据GDPR要求处理我的个人数据。",
  privacy_policy: "查看隐私政策",
  download_button: "下载白皮书(PDF)",
  download_generating: "生成中...",
  email_required: "请输入您的邮箱",
  agreement_required: "请同意隐私政策",
  download_success: "白皮书下载成功，感谢您使用我们的服务！",
  download_failed: "下载失败，请稍后再试",
  submit_error: "提交失败，请稍后再试",
};
